import React from "react";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { Tabs } from "antd";
import { useNavigate, useSearchParams } from "react-router";
import { useTranslation } from "react-i18next";
import Departure from "../../Pages/Departure";
import UpComming from "../../Pages/UpComming";
import { Container } from "reactstrap";
import { useSystem } from "@/utils/hooks/useLocation";
import usePermissions from "@/utils/hooks/usePermissions";
import { permissions } from "@/utils/constants";

export const MakkahCampain = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { currentSystem, location } = useSystem()
  const {
    hasAnyPermission
  } = usePermissions();

  const arrivalCampaignPermissions =
    currentSystem === "madina"
      ? [
          permissions.list_campaigns_for_madina,
          permissions.view_campaigns_for_madina,
          permissions.create_campaigns_for_madina,
          permissions.update_campaigns_for_madina,
          permissions.delete_campaigns_for_madina,
          permissions.list_campaign_details_for_madina,
          permissions.view_campaign_details_for_madina,
          permissions.create_campaign_details_for_madina,
          permissions.update_campaign_details_for_madina,
          permissions.delete_campaign_details_for_madina,
        ]
      : [
          permissions.list_campaigns,
          permissions.view_campaigns,
          permissions.create_campaigns,
          permissions.update_campaigns,
          permissions.delete_campaigns,
          permissions.list_campaign_details,
          permissions.view_campaign_details,
          permissions.create_campaign_details,
          permissions.update_campaign_details,
          permissions.delete_campaign_details,
        ];
  const departureCampaignPermissions =
    currentSystem === "madina"
      ? [
          permissions.list_departure_campaigns_for_madina,
          permissions.view_departure_campaigns_for_madina,
          permissions.list_departure_campaign_details_for_madina,
          permissions.view_departure_campaign_details_for_madina,
          permissions.create_departure_campaign_details_for_madina,
          permissions.update_departure_campaign_details_for_madina,
          permissions.delete_departure_campaign_details_for_madina,
        ]
      : [
          permissions.list_departure_campaigns,
          permissions.view_departure_campaigns,
          permissions.create_departure_campaigns,
          permissions.update_departure_campaigns,
          permissions.delete_departure_campaigns,
          permissions.list_departure_campaign_details,
          permissions.view_departure_campaign_details,
          permissions.create_departure_campaign_details,
          permissions.update_departure_campaign_details,
          permissions.delete_departure_campaign_details,
        ];

  const items = [
    hasAnyPermission(arrivalCampaignPermissions) && {
      key: "arrival-campaign",
      label: t("MAKKAH_CAMPAIGNS_UPCOMING"),
      children: <UpComming />,
    },
    hasAnyPermission(departureCampaignPermissions) && {
      key: "departure-campaign",
      label: t("MAKKAH_CAMPAIGNS_DEPARTURE"),
      children: <Departure />,
    },
  ].filter(Boolean);

  const fallbackSource = items[0]?.key;
  const sourceParam = searchParams.get("source");
  const pathSource = location.pathname.endsWith("/departure-campaign")
    ? "departure-campaign"
    : "arrival-campaign";
  const requestedSource = sourceParam || pathSource;
  const resolvedSource = items.some((item) => item.key === requestedSource)
    ? requestedSource
    : fallbackSource;

  React.useEffect(() => {
    if (!items.length || !resolvedSource) return;

    const pathMatchesResolved = location.pathname.endsWith(`/${resolvedSource}`);
    if (!pathMatchesResolved) {
      navigate(`/app/${currentSystem}/${resolvedSource}?source=${resolvedSource}`, { replace: true });
      return;
    }

    if (sourceParam !== resolvedSource) {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set("source", resolvedSource);
          return next;
        },
        { replace: true }
      );
    }
  }, [
    currentSystem,
    items,
    location.pathname,
    navigate,
    resolvedSource,
    setSearchParams,
    sourceParam,
  ]);

  const onChange = (key) => {
    navigate(`/app/${currentSystem}/${key}?source=${key}`);
  };

  return (
    <Stack gap={2}>
      <PageHeader title={t("MAKKAH_CAMPAIGNS_TITLE")} />

      <Container fluid>
        <Tabs
          activeKey={resolvedSource}
          items={items}
          onChange={onChange}
        />
      </Container>
    </Stack>
  );
};
